export default __webpack_public_path__ + "assets/icons/icon-arrow-down.7b4491db0fed3317fcd54ec100927df1.svg";